const STORAGE_KEY = 'featureFlagOverrides';

export function restoreOverrides(): void {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) {
      window.featureFlagOverrides = {
        ...window.featureFlagOverrides,
        ...JSON.parse(stored),
      };
    }
  } catch (e) {
    console.warn(
      'Failed to restore feature flag overrides from sessionStorage',
      e,
    );
    window.featureFlagOverrides = {};
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      // sessionStorage may be unavailable
    }
  }
}

export function persistOverrides(overrides: Record<string, boolean>): void {
  window.featureFlagOverrides = overrides;
  try {
    if (Object.keys(overrides).length > 0) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(overrides));
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch (e) {
    console.warn(
      'Failed to persist feature flag overrides to sessionStorage',
      e,
    );
  }
}

export function clearOverrides(): void {
  window.featureFlagOverrides = {};
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.warn(
      'Failed to clear feature flag overrides from sessionStorage',
      e,
    );
  }
}
